import { render, staticRenderFns } from "./AgtSecondStep.vue?vue&type=template&id=524028ca&"
import script from "./AgtSecondStep.vue?vue&type=script&lang=js&"
export * from "./AgtSecondStep.vue?vue&type=script&lang=js&"
import style0 from "./AgtSecondStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports